import { BottomSheet } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import OrderSheetLayout from '../common/OrderSheetLayout';
import AddEasyCardRow from './components/AddEasyCardRow';
import EasyCardRow from './components/EasyCardRow';
import useOrderEasyCards from './hooks/useOrderEasyCards';

declare module '@stackflow/config' {
    interface Register {
        OrderEasyCardBottomSheet: {};
    }
}

/** 결제에 사용할 간편카드 선택 */
const OrderEasyCardBottomSheet: ActivityComponentType<'OrderEasyCardBottomSheet'> = () => {
    const { t } = useTranslation('order');
    const {
        cards, selectedCardId, applyDisabled, selectCard, handleApply, handleAdd, handleClose,
    } = useOrderEasyCards();

    return (
        <BottomSheet>
            <OrderSheetLayout title={t('easyCardSheet.title')}
                closeLabel={t('easyCardSheet.close')}
                onClose={handleClose}
                applyLabel={t('easyCardSheet.select')}
                onApply={handleApply}
                applyDisabled={applyDisabled}>
                {cards?.map((card) => (
                    <EasyCardRow key={card.cardId}
                        card={card}
                        isSelected={selectedCardId === card.cardId}
                        onSelect={() => selectCard(card.cardId)} />
                ))}
                {cards?.length === 0 && <AddEasyCardRow onClick={handleAdd} />}
            </OrderSheetLayout>
        </BottomSheet>
    );
};

export default OrderEasyCardBottomSheet;
